/**
 * Bumped by hand on every deploy meant to change behaviour on a phone.
 *
 * It exists because "did the device actually get the new build?" was
 * unanswerable, and several fixes were judged against a build that may never
 * have reached the handset. Both surfaces show it as the first row of their
 * state readout, next to which surface is running — the two facts that have to
 * be established before anything else is worth discussing.
 */
export const BUILD_TAG = '2026-09-23d';
